import ViewPadrao from "../views/ViewPadrao";
import VendedorList from "../views/VendedorList";
import VendedorCad from "../views/VendedorCad";

export default {
  path: "vendedor",
  component: ViewPadrao,
  children: [
    {
      path: "lista",
      name: "vendedor-list",
      component: VendedorList,
    },
    {
      path: "novo",
      name: "vendedor-formulario",
      component: VendedorCad,
    },
    {
      path: "editar/:id",
      name: "vendedor-formulario-editar",
      component: VendedorCad,
    },
  ],
};
